<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年02月19日 22:15:29 +0800
 * @最后修改时间: 2021-09-06 15:01:36
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Event\EventType\editEventType.vue
 -->
<template>
  <ContentLayout
    widthClass="max-1000"
    backgroundClass="white"
    :title="
      iSEdited
        ? $t('label_essweb_eventType_from_editTitle')
        : $t('label_essweb_eventType_from_viewTitle')
    "
    delBtn
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    :initData="eventTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'event_type_status',
      'event_type_name',
      'event_type_description',
      'event_type_abbr',
      'event_type_code',
      'table_name',
      'view_name',
      'container_name',
      'color_code',
      'remarks',
    ]"
    @delete="
      $confirmDo($t('label_essweb_eventType_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row align="center" justify="start" class="white lighten-5">
          <!-- <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0 pb-0">
            <v-switch
              :filled="iSEdited"
              :disabled="!iSEdited"
              v-model="eventTypeData.event_type_status"
              class="ma-4"
              :label="
                eventTypeData.event_type_status
                  ? $t('label_essweb_eventType_from_activeTextLabel')
                  : ''
              "
            ></v-switch>
          </v-col> -->
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              maxlength="100"
              :readonly="!iSEdited"
              :bindData="eventTypeData.event_type_name"
              @change="
                (valueArr) => {
                  eventTypeData.event_type_name = valueArr;
                }
              "
              :label="$t('label_essweb_eventType_from_eventTypeNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              maxlength="20"
              :readonly="!iSEdited"
              :bindData="eventTypeData.event_type_abbr"
              @change="
                (valueArr) => {
                  eventTypeData.event_type_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_eventType_from_eventTypeAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="mrc_text_require text--secondary pl-1 mt-1">{{
              $t("label_essweb_eventType_from_tagColorLabel")
            }}</v-sheet>
            <SelectColor
              :items="$Colors"
              v-model="eventTypeData.color_code"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :height="40"
              :appendIcon="iSEdited ? 'arrow_drop_down' : ''"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="eventTypeData.event_type_description"
              maxlength="500"
              @change="
                (valueArr) => {
                  eventTypeData.event_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_eventType_from_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :label="$t('label_essweb_eventType_from_eventTypeCodeLabel')"
              :readonly="!iSEdited"
              maxlength="100"
              :filled="iSEdited"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="eventTypeData.event_type_code"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12" offset-md="0">
            <v-sheet class="mrc_text_require text--secondary">
              {{ $t("label_essweb_eventType_from_tableNameLabel") }}</v-sheet
            >
            <v-autocomplete
              :items="tables"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :filled="iSEdited"
              :disabled="true"
              item-text="view_fields"
              item-value="value_field"
              v-model="eventTypeData.table_name"
              single-line
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :readonly="!iSEdited"
              :label="$t('label_essweb_eventType_from_tableNameLabel')"
              dense
            >
              <template v-slot:no-data> <noContent /> </template>
              <template v-slot:selection="data">
                {{ $getCommonLangValue(data.item.view_fields) }}
              </template>
              <template v-slot:item="data">
                <div class="table-title text--primary">
                  {{ $getCommonLangValue(data.item.view_fields) }}
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- <v-col xs="12" sm="6" md="6" lg="6" cols="12" offset-md="0">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_eventType_from_viewNameLabel") }}</v-sheet
            >
            <v-autocomplete
              :items="views"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :filled="iSEdited"
              v-model="eventTypeData.view_name"
              single-line
              item-text="view_fields"
              item-value="value_field"
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :readonly="!iSEdited"
              :label="$t('label_essweb_eventType_from_viewNameLabel')"
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_eventType_from_containerLabel") }}
            </v-sheet>
            <v-autocomplete
              :items="items"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :filled="iSEdited"
              v-model="eventTypeData.container_name"
              single-line
              :readonly="!iSEdited"
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :label="$t('label_essweb_eventType_from_containerLabel')"
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">
              {{ $t("label_essweb_eventType_from_remarkLabel") }}
            </v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              :filled="iSEdited"
              v-model="eventTypeData.remarks"
              single-line
              :readonly="!iSEdited"
              dense
              counter="500"
              name="input-7-4"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- content -->
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        saveBtn
        @save="toSave"
        v-if="iSEdited"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main> </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newEvent",
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
  },
  mounted() {
    const that = this;
    //获取表名
    // 获取表名
    this.$findPrompt({
      prompt_name: "ess_event_table_select",
      table_type: 1,
    }).then((res) => {
      that.tables = res.data;
    });
    //获取表视图
    // this.$findPrompt({
    //
    //   prompt_name: "ess_table_select",
    //   table_type: 2,

    // })
    //   .then((res) => {
    //     that.views = res.data;
    //   })
    //   .catch((err) => {
    //     that.$showMessage({ color: "error",type:"error", text: err });
    //   });
    this.getEventTypeDetailByUuid();
  },
  data() {
    return {
      iSEdited: true,
      tab: null,
      isChanged: false,
      eventTypeData: {
        uuid: "",
        event_type_status: false,
        event_type_name: "",
        event_type_description: "",
        event_type_abbr: "",
        table_name: "",
        view_name: "",
        container_name: "",
        event_type_code: "",
        effective_utc_start_date: "",
        effective_start_time_zone: "",
        effective_utc_end_date: "",
        effective_end_time_zone: "",
        color_code: "",
        remarks: "",
      },
      tables: [
        "ess_att_event_break",
        "ess_att_event_duty",
        "ess_att_event_meal",
      ],
      views: [],
      items: [],
    };
  },
  methods: {
    toBack: function () {
      // if (this.iSEdited) {
      //   this.iSEdited = false;
      // } else {
      this.$router.back();
      // }
    },

    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/delete-event-type-table/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_eventType_list_deleteEventTypeSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/update-event-type-table/",
        data: {
          event_type_status: this.eventTypeData.event_type_status ? 1 : 0,
          uuid: this.$route.params.id,
          event_type_name: this.$transCommonLangKey(
            this.eventTypeData.event_type_name,
            this.eventTypeData.event_type_name_save
          ),
          event_type_description: this.$transCommonLangKey(
            this.eventTypeData.event_type_description,
            this.eventTypeData.event_type_description_save
          ),
          event_type_abbr: this.$transCommonLangKey(
            this.eventTypeData.event_type_abbr,
            this.eventTypeData.event_type_abbr_save
          ),
          // view_name: this.eventTypeData.view_name,
          // container_name: this.eventTypeData.container_name,
          event_type_code: this.eventTypeData.event_type_code,
          color_code: this.eventTypeData.color_code,
          remarks: this.eventTypeData.remarks,
        },
      }).then((res) => {
        that.toBack(); //回到不能编辑状态
        that.$showMessage({
          text: that.$t(
            "message_essweb_eventType_list_updateEventTypeSuccessLabel"
          ),
          type: "success",
        });
      });
    },
    getEventTypeDetailByUuid: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "event_event_type",
        url: "/event-type/get-event-type-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        res.data["event_type_name_save"] = res.data.event_type_name;
        res.data.event_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.event_type_name
        );
        res.data["event_type_description_save"] =
          res.data.event_type_description;
        res.data.event_type_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.event_type_description
        );
        res.data["event_type_abbr_save"] = res.data.event_type_abbr;
        res.data.event_type_abbr = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.event_type_abbr
        );
        that.eventTypeData = res.data;
      });
    },
    toEdit: function () {
      this.iSEdited = true;
    },
  },
};
</script>
